import * as React from 'react'

function SvgWarnIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M11.156 11.344V8.32h1.68v3.024l-.24 2.088h-1.2l-.24-2.088ZM11.12 16v-1.704h1.764V16H11.12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10 8a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgWarnIcon
